(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vpa-entry-status"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const safePortalUrl = (raw) => {
    if (typeof raw !== 'string' || raw.length > 2048 || /[\u0000-\u0020\u007f\\]/.test(raw)) return null;
    try {
      const url = new URL(raw);
      if (url.protocol !== 'https:' || !url.hostname || url.username || url.password) return null;
      url.hash = '';
      url.searchParams.delete('embed');
      url.searchParams.delete('parent_origin');
      return url;
    } catch { return null; }
  };
  function mount(container) {
    if (instances.has(container)) return;
    const fallback = container.querySelector('[data-entry-fallback]');
    const status = container.querySelector('[data-entry-status]');
    const host = container.querySelector('[data-entry-frame]');
    const url = safePortalUrl(container.dataset.portalUrl);
    if (!url) {
      fallback.removeAttribute('href');
      fallback.hidden = true;
      status.textContent = container.dataset.unavailable;
      return;
    }
    fallback.href = url.href;
    const frame = document.createElement('iframe');
    frame.title = container.dataset.frameTitle;
    frame.className = 'entry-portal-frame';
    frame.loading = 'lazy';
    frame.referrerPolicy = 'strict-origin';
    frame.setAttribute('sandbox', 'allow-scripts allow-forms allow-same-origin allow-top-navigation-by-user-activation allow-popups allow-popups-to-escape-sandbox');
    frame.setAttribute('allow', 'camera \'none\'; microphone \'none\'; geolocation \'none\'');
    const state = { frame, origin: url.origin, channel: crypto.randomUUID(), ready: false, timer: null, observer: null };
    instances.set(container, state);
    const startTimer = () => {
      if (state.ready || state.timer) return;
      state.timer = window.setTimeout(() => {
        if (!state.ready) {
          status.textContent = container.dataset.fallbackMessage;
          frame.hidden = true;
        }
      }, 12000);
    };
    frame.addEventListener('load', () => {
      state.ready = false;
      status.hidden = false;
      status.textContent = container.dataset.loading;
      clearTimeout(state.timer);
      state.timer = null;
      startTimer();
      frame.contentWindow?.postMessage({ type: 'vpa:entry:init', version: 1, channel: state.channel }, state.origin);
    });
    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { startTimer(); state.observer.disconnect(); }
      }, { rootMargin: '300px' });
      state.observer.observe(container);
    }
    const embedded = new URL(url.href);
    embedded.searchParams.set('embed', '1');
    embedded.searchParams.set('parent_origin', window.location.origin);
    frame.src = embedded.href;
    host.append(frame);
  }
  function mountAll(root = document) {
    if (root.matches?.('[data-entry-portal]')) mount(root);
    root.querySelectorAll('[data-entry-portal]').forEach(mount);
  }
  window.addEventListener('message', (event) => {
    const data = event.data;
    if (!data || typeof data !== 'object' || Array.isArray(data) || data.version !== 1) return;
    if (data.type !== 'vpa:entry:ready' && data.type !== 'vpa:entry:resize') return;
    if (!Number.isFinite(data.height) || data.height < 160 || data.height > 24000) return;
    for (const [container, state] of instances) {
      if (event.source !== state.frame.contentWindow || event.origin !== state.origin || data.channel !== state.channel) continue;
      state.frame.style.height = `${Math.max(360, Math.ceil(data.height) + 8)}px`;
      if (data.type === 'vpa:entry:ready') {
        state.ready = true;
        state.frame.hidden = false;
        clearTimeout(state.timer);
        container.querySelector('[data-entry-status]').hidden = true;
      }
    }
  });
  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [container, state] of instances) {
      if (!event.target.contains(container)) continue;
      clearTimeout(state.timer);
      state.observer?.disconnect();
      instances.delete(container);
    }
  });
  mountAll();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vpa-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  function gallery(root) {
    if(root.dataset.galleryReady)return;
    const viewport=root.querySelector('[data-gallery-viewport]'),track=root.querySelector('[data-gallery-track]'),originals=[...track.children],toggle=root.querySelector('[data-gallery-motion]');
    if(originals.length<2)return;
    root.dataset.galleryReady='true';root.querySelector('[data-gallery-controls]').hidden=false;
    const media=matchMedia('(prefers-reduced-motion: reduce)'),lifecycle=new AbortController(),opts={signal:lifecycle.signal};
    let cycle=0,position=0,previous=0,frame=0,visible=false,hover=false,focus=false,paused=root.dataset.autoplay!=='true';
    for(const item of originals){const clone=item.cloneNode(true);clone.removeAttribute('data-gallery-item');clone.removeAttribute('data-shopify-editor-block');clone.setAttribute('aria-hidden','true');clone.inert=true;clone.querySelectorAll('img').forEach(img=>img.alt='');track.append(clone);}
    function size(){cycle=track.children[originals.length].offsetLeft-originals[0].offsetLeft;position=viewport.scrollLeft;}
    function controls(){toggle.hidden=media.matches;toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-pressed',String(paused));}
    function stop(){paused=true;controls();}
    function advance(direction){stop();const amount=originals[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);if(direction<0&&viewport.scrollLeft<1&&cycle>0)viewport.scrollLeft=cycle;viewport.scrollBy({left:direction*amount,behavior:media.matches?'auto':'smooth'});}
    root.querySelector('[data-gallery-prev]').addEventListener('click',()=>advance(-1),opts);root.querySelector('[data-gallery-next]').addEventListener('click',()=>advance(1),opts);
    toggle.addEventListener('click',()=>{paused=!paused;position=viewport.scrollLeft;controls();},opts);
    root.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')hover=true;},opts);root.addEventListener('pointerleave',()=>hover=false,opts);
    root.addEventListener('focusin',()=>focus=true,opts);root.addEventListener('focusout',()=>queueMicrotask(()=>focus=root.contains(document.activeElement)),opts);
    viewport.addEventListener('pointerdown',stop,opts);viewport.addEventListener('wheel',stop,{...opts,passive:true});viewport.addEventListener('scroll',()=>{position=viewport.scrollLeft;},{...opts,passive:true});
    viewport.addEventListener('keydown',event=>{if(event.target!==viewport)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();stop();if(event.key==='Home')viewport.scrollLeft=0;else if(event.key==='End')viewport.scrollLeft=Math.max(0,cycle-viewport.clientWidth);else advance(event.key==='ArrowLeft'?-1:1);}},opts);
    media.addEventListener('change',controls,opts);
    const observer=new IntersectionObserver(entries=>{visible=entries.some(entry=>entry.isIntersecting);},{threshold:0.05});observer.observe(root);
    const resize=new ResizeObserver(size);resize.observe(track);size();controls();
    function tick(time){const delta=Math.min(time-previous,60);previous=time;if(visible&&!paused&&!hover&&!focus&&!media.matches&&!document.hidden&&cycle>0){position+=delta*.024;if(position>=cycle)position-=cycle;viewport.scrollLeft=position;}frame=requestAnimationFrame(tick);}
    frame=requestAnimationFrame(tick);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();lifecycle.abort();}},{signal:lifecycle.signal});
  }
  document.querySelectorAll('[data-vpa-gallery]').forEach(gallery);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-vpa-gallery]').forEach(gallery));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vpa-header"] && !Shopify.designMode) return;
  try {
    
const vpaStickyHeader=document.querySelector('.site-header');
if(vpaStickyHeader){
 const updateHeaderHeight=()=>document.documentElement.style.setProperty('--vpa-header-height',Math.ceil(vpaStickyHeader.getBoundingClientRect().height)+'px');
 updateHeaderHeight();
 if('ResizeObserver' in window)new ResizeObserver(updateHeaderHeight).observe(vpaStickyHeader);
}
const vpaHeroAction=document.querySelector('.hero-actions>.button');
const vpaMobileEntryBar=document.querySelector('.mobile-entry-bar');
if(vpaHeroAction&&vpaMobileEntryBar&&'IntersectionObserver' in window){
 new IntersectionObserver(([entry])=>{vpaMobileEntryBar.hidden=entry.isIntersecting&&entry.intersectionRatio>=0.95;},{rootMargin:'-120px 0px 0px 0px',threshold:[0,0.95,1]}).observe(vpaHeroAction);
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('.mobile-menu').open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});

  } catch(e) { console.error(e); }
})();
})();
